import { Avatar, AvatarUser, Badge } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { ComponentProps, ReactNode } from 'react';

import { AppLink } from 'components/appLink';

import styles from './contactsListItem.module.scss';

interface ContactsListItemProps {
  /** The primary label of the item. */
  primaryLabel: ReactNode;
  /** The secondary label of the item. */
  secondaryLabel?: ReactNode;
  /** The data for the avatar element. */
  avatar: AvatarUser;
  /** The badge text. */
  badgeText?: string;
  /** The AppLink component props. */
  appLinkProps: ComponentProps<typeof AppLink>;
  /** Whether or not the item is selected. */
  selected?: boolean;
}

/** Generic component for a contacts list item. */
export function ContactsListItem({
  primaryLabel,
  secondaryLabel,
  avatar,
  badgeText,
  appLinkProps,
  selected,
}: ContactsListItemProps): JSX.Element {
  return (
    <AppLink
      className={classnames(styles.root, { [styles.selected]: selected })}
      {...appLinkProps}
    >
      <Avatar className={styles.avatar} size="40" user={avatar} />

      {badgeText && (
        <Badge className={styles.badge} size="small" variant="secondary">
          {badgeText}
        </Badge>
      )}

      <div className={styles.primary} data-testid="primaryLabel">
        {primaryLabel}
      </div>

      {secondaryLabel && (
        <div className={styles.secondary} data-testid="secondaryLabel">
          {secondaryLabel}
        </div>
      )}
    </AppLink>
  );
}
